export default class SortByController {
  /* @ngInject */
}



// WEBPACK FOOTER //
// ./src/components/sort-by/sort-by.controller.js